import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const links = [
  { label: 'Serviços', href: '#servicos' },
  { label: 'Horários', href: '#horarios' },
  { label: 'Instrutores', href: '#instrutores' },
  { label: 'Preços', href: '#precos' },
  { label: 'Contacto', href: '#contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-cream/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
          className="font-playfair text-2xl font-light tracking-[0.3em] text-ink cursor-pointer"
        >
          AURA
        </a>

        {/* Desktop */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => handleNav(l.href)}
              className="font-dm text-sm text-ink-light hover:text-sage transition-colors duration-200 tracking-wide cursor-pointer"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => handleNav('#contacto')}
            className="font-dm text-sm bg-sage text-white px-5 py-2 rounded-full hover:bg-sage-dark transition-colors duration-300 cursor-pointer"
          >
            Reservar
          </button>
        </nav>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-ink cursor-pointer"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-400 ${open ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="bg-cream/95 backdrop-blur-md px-6 pb-6 pt-3 flex flex-col gap-4">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => handleNav(l.href)}
              className="font-dm text-base text-ink-light hover:text-sage transition-colors text-left cursor-pointer"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => handleNav('#contacto')}
            className="font-dm text-sm bg-sage text-white px-5 py-2.5 rounded-full w-fit cursor-pointer"
          >
            Reservar Aula
          </button>
        </div>
      </div>
    </header>
  );
}
